import { showToast } from "../components";
import { ENDPOINTS } from "../redux/apiConfig";
import axiosRequest from "../redux/slices/universal/axiosService";

  const collectionNames = {
    //endpoint names as per apiConfig.js
    //collection names as per db collections
    Invoice: {
      endpoint: "INVOICES",
      collection: "Invoice",
    },
    Account_Payable: {
      endpoint: "ACCOUNT_PAYBLES",
      collection: "AccountPayable",
    },
    Employee: {
      endpoint: "EMPLOYEES",
      collection: "Employee",
    },
  };

export const getDashboardData = async (data, collection, lim, pg) => {
  try {
    if (!collection) throw new Error("Collection not provided");
    const dashboardData = await axiosRequest({
      method: "GET",

      // url: ENDPOINTS[`${(collectionNames[collection].endpoint).toUpperCase()}`].GET_ALL,
      url: ENDPOINTS[`${(collectionNames[collection].endpoint)}`].GET_ALL,
      params: {
        lim,
        pg,
        useAggregate: true,
        coll: collectionNames[collection].collection,
        fil: JSON.stringify(data),
      },
    });
    return dashboardData?.data?.data || {};
  } catch (error) {
    console.error("Error fetching dashboard data:", error.response || error);
    showToast("Error fetching dashboard data", "error");
  }
};
